export default __webpack_public_path__ + "static/media/cropped-box.8de4ca38.svg";